const diseases = [
  { text: 'Cardiovascular', value: 'cardiovascular-diseases' },

  {
    text: 'Ischemic heart disease',
    value: 'ischemic-heart-disease',
    specific: true,
  },
  {
    text: 'Other heart diseases',
    value: 'other-heart-diseases',
    specific: true,
  },
  {
    text: 'Cerebrovascular disease',
    value: 'cerebrovascular-disease',
    specific: true,
  },
  { text: 'Neoplasm', value: 'neoplasm' },
  { text: 'Cancer', value: 'cancer' },
  {
    text: 'Breast cancer',
    value: 'breast-cancer',
    specific: true,
    male: false,
  },
  {
    text: 'Ovarian cancer',
    value: 'ovarian-cancer',
    specific: true,
    male: false,
  },
  {
    text: 'Cervical cancer',
    value: 'cervical-cancer',
    specific: true,
    male: false,
  },
  { text: 'Liver cancer', value: 'liver-cancer', specific: true },
  { text: 'Lung cancer', value: 'lung-cancer', specific: true },
  { text: 'Colorectal cancer', value: 'colorectal-cancer', specific: true },

  { text: 'Leukaemia', value: 'leukaemia', specific: true },
  { text: 'Stomach cancer', value: 'stomach-cancer', specific: true },
  { text: 'External causes', value: 'external-causes' },
  { text: 'Transport Accidents', value: 'transport-accidents', specific: true },
  {
    text: 'Diseases of the nervous system',
    value: 'diseases-of-the-nervous-system',
  },
  {
    text: 'Endocrine, nutritional, metabolic diseases',
    value: 'endocrine-nutritional-metabolic-diseases',
  },
  { text: 'Diabetes mellitus', value: 'diabetes-mellitus', specific: true },
  { text: 'Ill-defined causes', value: 'ill-defined-causes' },
  {
    text: 'Mental and behavioural disorders',
    value: 'mental-and-behavioural-disorders',
  },
  { text: 'Digestive diseases', value: 'digestive-diseases' },
  {
    text: 'Congenital and perinatal diseases',
    value: 'congenital-and-perinatal-diseases',
  },
  { text: 'Blood diseases', value: 'blood-diseases' },

  // { text: 'Accidents', value: 'accidents', specific: true },
  // { text: 'Suicides', value: 'suicides', specific: true },

  // {
  //   text: 'Drug overdose (unintentional)',
  //   value: 'drug-overdose-unintentional',
  //   specific: true,
  // },

  // { text: 'Infectious', value: 'infectious' },

  // { text: 'Other', value: 'other' },
  {
    text: 'Pregnancy, childbirth and the puerperium',
    value: 'pregnancy-childbirth-and-the-puerperium',
    male: false,
  },
  { text: 'Eye and ear diseases', value: 'eye-and-ear-diseases' },
  {
    text: 'Skin, connective and musculoskeletal diseases',
    value: 'skin-connective-and-musculoskeletal-diseases',
  },
  // { text: 'Perinatal', value: 'perinatal' },
  { text: 'Infectious diseases', value: 'infectious-diseases' },
  { text: 'Tuberculosis', value: 'tuberculosis', specific: true },
  { text: 'Genitourinary diseases', value: 'genitourinary-diseases' },
  { text: 'Respiratory diseases', value: 'respiratory-diseases' },
  { text: 'Pneumonia', value: 'pneumonia', specific: true },
];
module.exports = diseases;
// export default diseases
